import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { mediaQuery } from 'src/assets/media-query-config';

/** @description Entire page wrapper */
export const LayoutWrapper = styled('div', { label: 'LayoutWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    min-height: 100%;
`;

/** @description Main container - (LHS + MainContent) wrapper */
export const MainContainer = styled('div', { label: 'MainContainer' })`
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 0%;
`;

/** @description Main content - (MainContainer - LHS) wrapper */
export const MainContent = styled('main', { label: 'MainContent' })`
    background-color: #F4F4F5; 
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 calc(100% - 200px);
    width: 100%;
    padding: 16px 0 48px;

    @media ${mediaQuery.xLargeDesktop} {
        padding: 12px 12px 12px 0;
    }
`;

/** Columns layout */
export const TwoColumnResponsiveContentReverse = styled('div', { label: 'TwoColumnResponsiveContentReverse' })`
    display: flex;
    flex-flow: column nowrap;
    font-family: var(--fontFamilyPrimary);
    > div:last-of-type {
        border-bottom: 1px solid ${mainColors.grays.gray200};
        margin-bottom: 24px;
        order: -1;
        padding-bottom: 24px;
    }
    @media ${mediaQuery.xLargeDesktop} {
        display: grid;
        grid-template-columns: 1.25fr 0.9fr;
        gap: 0 20px;
        > div:last-of-type {
            border: none;
            margin: 0;
            order: 0;
            padding: 0;
        }
    }
`;

export const ColumnOneOfTwo = styled('div', { label: 'ColumnOneOfTwo' })`
    &:empty {
        display: contents;
        margin: 0;
        padding: 0;
    }
`;

export const ColumnOneOfTwoV2 = styled('div', { label: 'ColumnOneOfTwoV2' })`
    padding: 24px 16px !important;
    background-color: ${mainColors.default.light};
    max-height: calc(100vh - 24px);
    overflow: auto;
    display: flex;
    flex-direction: column;

    &:empty {
        display: contents;
        margin: 0;
        padding: 0;
    }
`;
